"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromCandid = void 0;
const userId_1 = require("../candidConverters/userId");
function fromCandid(connectionDetails) {
    if (connectionDetails.hasOwnProperty("Offer")) {
        const offer = connectionDetails.Offer;
        return {
            kind: "offer",
            id: offer.id,
            userId: userId_1.fromCandid(offer.user_id),
            connectionString: offer.connection_string,
            iceCandidates: offer.ice_candidates,
            ageSeconds: offer.age_seconds
        };
    }
    else if (connectionDetails.hasOwnProperty("Answer")) {
        const answer = connectionDetails.Answer;
        return {
            kind: "answer",
            id: answer.id,
            offerId: answer.offer_id,
            userId: userId_1.fromCandid(answer.user_id),
            connectionString: answer.connection_string,
            iceCandidates: answer.ice_candidates,
            ageSeconds: answer.age_seconds
        };
    }
    else {
        throw new Error("Unrecognised connection details type");
    }
}
exports.fromCandid = fromCandid;
